import { theme, Typography } from "antd";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AddressesList } from "../../../shared/container/Addresses/AddressesList/AddressesList";
import { useParams } from "react-router-dom";
import routes from "../../../engine/routes";
import { typeAddress } from "../../../shared/container/Addresses/AddresseItem/AddresseHelpers";

export const InstitutionAddresses = () => {
  const {} = useSelector(state => state.addresses);
  const { institution } = useSelector(state => state.institution);

  const { id } = useParams();

  const {
    token: { colorPrimary },
  } = theme.useToken();

  return (
    <>
      <Typography.Title level={3} className={""}>
        {routes.institutions(id).addresses.title}
      </Typography.Title>
      {institution._id !== undefined && (
        <AddressesList institution={institution} type={typeAddress.postal} />
      )}
    </>
  );
};
